// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"a584a2cc","165":"c426769b","246":"915290a6","505":"de429eb4","549":"f84f8cd6"}[chunkId] + ".chunk.css";
};